module.exports = __webpack_public_path__ + "img/Bodice-Front-B2-Ce-Db-Ec-Gb.a167a41d.png";